import React, { useContext } from "react";
import "./css/Footer.css";
import { LanguageContext } from "./LanguageContext";
import logo from "./images/logo3.png";

const Footer = () => {
  const { language, toggleLanguage } = useContext(LanguageContext);

  return (
    <footer className="footerLP">
      

      <div className="footerLP__container">
        {/* LEFT: Logo + Social + Copyright */}
        <div className="footerLP__left">
          <a href="/" className="footerLP__brand" aria-label="InvestDecoded">
            <img src={logo} alt="InvestDecoded" className="footerLP__logo" />
          </a>

          <div className="footerLP__socialRow">
            <a
              href="https://www.instagram.com/investdecoded/"
              target="_blank"
              rel="noopener noreferrer"
              className="footerLP__socialPill"
              aria-label="Instagram"
              title="Instagram"
            >
              <i className="fa-brands fa-instagram" />
            </a>

            <a
              href="https://www.linkedin.com/company/invest-decoded/"
              target="_blank"
              rel="noopener noreferrer"
              className="footerLP__socialPill"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              <i className="fa-brands fa-linkedin" />
            </a>

            <a
              href="https://www.youtube.com/@InvestDecoded"
              target="_blank"
              rel="noopener noreferrer"
              className="footerLP__socialPill"
              aria-label="YouTube"
              title="YouTube"
            >
              <i className="fa-brands fa-youtube" />
            </a>
          </div>

          <p className="footerLP__copy">
            © {new Date().getFullYear()} InvestDecoded.{" "}
            {language === "pt"
              ? "Todos os direitos reservados."
              : "All rights reserved."}
          </p>
        </div>

        {/* RIGHT: Columns */}
        <div className="footerLP__cols">
          {/* Column 1 */}
          <div className="footerLP__col">
            <h4 className="footerLP__title">
              {language === "pt" ? "Links Rápidos" : "Quick Links"}
            </h4>
            <ul className="footerLP__list">
              <li>
                <a className="footerLP__link" href="/courses">
                  {language === "pt" ? "Cursos" : "Courses"}
                </a>
              </li>
              <li>
                <a className="footerLP__link" href="/tutoring">
                  {language === "pt" ? "Coaching" : "Coaching"}
                </a>
              </li>
              <li>
                <a className="footerLP__link" href="/careers">
                  {language === "pt" ? "Carreiras" : "Careers"}
                </a>
              </li>
            </ul>
          </div>

          {/* Column 2 */}
          <div className="footerLP__col">
            <h4 className="footerLP__title">
              {language === "pt" ? "Siga-nos" : "Follow Us"}
            </h4>
            <ul className="footerLP__list">
              <li>
                <a
                  className="footerLP__link"
                  href="https://www.instagram.com/investdecoded/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  className="footerLP__link"
                  href="https://www.linkedin.com/company/invest-decoded/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  className="footerLP__link"
                  href="https://www.youtube.com/@InvestDecoded"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  YouTube
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="footerLP__col">
            <h4 className="footerLP__title">
              {language === "pt" ? "Fale Conosco" : "Contact Us"}
            </h4>
            <p className="footerLP__text">
              Email: <span className="footerLP__email">investdecoded@investdecoded.com</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
